import * as React from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';

interface CardItemProps {
  title: string;
  body?: React.ReactNode;
  style?: any;
  disabled?: boolean;
  active?: boolean;
  onPress?: () => void;
}

export const CardItem = ({
  title,
  body,
  style,
  disabled = false,
  active = false,
  onPress,
}: CardItemProps) => {
  const { styles, theme } = useStyles(stylesheet);
  const [hover, setHover] = React.useState(false);

  const getStyle = () => {
    const showDisabled = disabled;
    let stateStyle = styles.default;

    if (showDisabled) {
      stateStyle = styles.disabled;
    }
    if (hover) {
      stateStyle = styles.hover;
    }
    if (active) {
      stateStyle = styles.active;
    }

    return [stateStyle];
  };

  return (
    <Pressable
      style={[styles.container, getStyle(), style]}
      onHoverIn={() => setHover(true)}
      onHoverOut={() => setHover(false)}
      hitSlop={8}
      onPress={() => onPress?.()}
    >
      <View style={{ justifyContent: 'center', alignItems: 'center' }}>
        <Text
          type="bodyBold"
          style={{
            ...(disabled ? { color: theme.colors.text.secondary50 } : {}),
          }}
        >
          {title}
        </Text>

        {body}
      </View>
    </Pressable>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    width: 310,
    borderRadius: 16,
    padding: 16,
    borderWidth: 1,
  },
  default: {
    backgroundColor: theme.colors.card.default.backgroundColor,
    borderColor: theme.colors.card.default.borderColor,
  },
  active: {
    backgroundColor: theme.colors.card.active.backgroundColor,
    borderColor: theme.colors.card.active.borderColor,
    borderWidth: 1,
  },
  hover: {
    backgroundColor: theme.colors.card.hover.backgroundColor,
    borderColor: theme.colors.card.hover.borderColor,
  },
  disabled: {
    backgroundColor: theme.colors.card.disabled.backgroundColor,
    borderColor: theme.colors.card.disabled.borderColor,
  },
}));
